// Formatting + small helpers
export const inr = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '\u20b90';
  return '\u20b9' + Number(n).toLocaleString('en-IN', { maximumFractionDigits: 0 });
};

export const discountPct = (price, mrp) => {
  if (!mrp || mrp <= price) return 0;
  return Math.round(((mrp - price) / mrp) * 100);
};

export const cx = (...args) => args.filter(Boolean).join(' ');

export const truncate = (s, n = 60) => (s && s.length > n ? s.slice(0, n) + '\u2026' : s);
